<template>
  <section class="listing">
    <div class="header">
      <div class="title">Produtos</div>
      <button @click="$router.push('/product/new')" class="button-new"><i class="fas fa-plus"></i><span>NOVO</span></button>
    </div>
    <transition name="show" mode="out-in">
      <i v-if="loading" class="fas fa-spinner loading-big"></i>
      <div v-if="!loading">
        <div v-for="p in products" :key="p.id" class="list">
          <div class="data">
            <div class="main-data">{{ p.name }}</div>
            <div class="detail-data">R$ {{ p.price.toLocaleString('pt-br', { minimumFractionDigits: 2 }) }}</div>
          </div>
          <div style="text-align: right;margin-right: 20px;">
            <div class="main-data">{{ p.active ? 'VISÍVEL' : 'OCULTO' }}</div>
          </div>
          <div class="actions">
            <!-- <button  @click="remove(p.id)" class="button-action" style="margin-right: 5px"><i class="fas fa-trash-alt"></i><span>EXCLUIR</span></button> -->
            <button @click="$router.push(`/product/${p.id}`)" class="button-action"><i class="fas fa-pen"></i><span>ALTERAR</span></button>
          </div>
        </div>
      </div>
    </transition>
    <Product v-if="product" :id="product" :productData="productData" />
  </section>
</template>

<script>
import logger from '../../logger'
import { getAll, remove } from '../api/product'
import Product from './Product.vue'

export default {
  name: 'products',
  components: { Product },
  props: ['id'],
  data () {
    return {
      loading: true,
      product: null,
      products: [],
      productData: null
    }
  },
  watch: {
    async '$route' (value) {
      this.product = value.params['id'] || null
      // Update list
      if (!value.params['id']) {
        this.getData()
      } else {
        this.productData = this.products.find(x => x.id === Number(value.params['id']))
      }
    }
  },
  async mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      try {
        this.product = this.id || null
        this.products = await getAll()
        this.loading = false
      } catch (error) {
        logger.error(error, this)
      }
    },
    async remove (id) {
      try {
        if (this.loading) return false
        this.loading = true
        // Update user
        await remove(id)
        this.loading = false
        this.getData()
      } catch (error) {
        logger.error(error, this)
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../_asset/scss/_variables";
.list {
  border: 1px solid #918f8f;
}
</style>
